
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_49131","data-name":"Group 49131","xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_38423","data-name":"Path 38423","d":"M12.493 9.2l-1.5 1.582-.7-.714 2.339-2.409h1.023V17h-1.162z","fill":"#5858ec"}}),_c('g',{attrs:{"id":"Group_49125","data-name":"Group 49125"}},[_c('g',{attrs:{"id":"Group_49126","data-name":"Group 49126"}},[_c('path',{attrs:{"id":"Path_38424","data-name":"Path 38424","d":"M25 20.313V4.688A4.692 4.692 0 0020.313 0H4.688A4.693 4.693 0 000 4.688v15.625A4.692 4.692 0 004.688 25h15.625A4.693 4.693 0 0025 20.313M20.313 1.042a3.649 3.649 0 013.646 3.646v15.625a3.649 3.649 0 01-3.646 3.646H4.688a3.649 3.649 0 01-3.646-3.646V4.688a3.649 3.649 0 013.646-3.646z","fill":"#5858ec"}})])])])
          )
        }
      }
    